import {InjectionToken} from "@angular/core";

export interface ModalData {
  [key: string]: any;
}

export const MODAL_DATA = new InjectionToken<ModalData>('modal.data');
